module.exports = __webpack_public_path__ + "img/banner4.64f57682.png";